export interface StripeInfo {
	viewvalue: string;
	viewtype: ViewType;
	text: string;
	stripecolor: string;
}

export interface UserInfo {
	isLogged: boolean;
	userName: string;
	numelchart: number;
	hrefchart: string;
	htmlHeader: string;
	htmlFooter: string;
	stripeActive: StripeInfo[];
}

export enum ViewType {
	Homepage = 'HomePage',
	Cart = 'Carrello',
	Search = 'Ricerca',
	Catalog = 'Catalogo',
	LineId = 'IdLinea',
	SheetId = 'IdScheda',
	ProductCode = 'CodiceProdotto',
	CustomUrl = 'URLCustom',
}
